<template>
  <div id="AddDoubt" class="component-wrapper">
  	<div class="add-query">
    <h4>Have a doubt?</h4>
    <div id="the_form" class="">
      <b-form @submit="onSubmit">
        <b-form-group id="exampleInputGroup1"
            label=""
            label-for="exampleInput1"
            description="">
          <b-form-input id="exampleInput1"
                type="text"
                v-model="form.title"
                required
                placeholder="Query Title">
          </b-form-input>
        </b-form-group>
        <b-form-group id="exampleInputGroup2"
            label=""
            label-for="exampleInput2"
            description="">
		    <b-form-select v-model="form.tags">
          <!-- <template slot="first">
            <option :value="null" disabled="">Select a tag</option>
          </template> -->
		      <option v-for="tag in doubt_tags" :value="tag">{{capitalize(tag)}}
          </option>
		    </b-form-select>
        </b-form-group>
        <b-form-group id="exampleInputGroup3"
            label=""
            label-for="exampleInput3"
            description="">
            <b-form-textarea id="textarea1"
                     v-model="form.description"
                     placeholder="Type your doubt here"
                     :rows="3"
                     :max-rows="6">
    		</b-form-textarea>
        </b-form-group>
        <div>
        	<b-container class="shadow-1">
    				<b-row align-v="center">
    					<b-col sm="12" class="action" style="padding-left:0">
    					 	<b-dropdown variant="link" no-caret>
    					 	    <template slot="button-content">
    					 	      <img src="/static/symbol.png">
                      <a href="#" style="font-size:1rem;" class="add-symbol" id="add-symbol">Add Symbols</a>
    					 	    </template>
    					 	    <b-dropdown-item href="#">
    				              <li class="symbol-item"><a @click="addSymbol('∆')" href="#" class="logic-symbol">&#8710;</a></li>
    				              <li class="symbol-item"><a @click="addSymbol('∏')" href="#" class="logic-symbol">&prod;</a></li>
    				              <li class="symbol-item"><a @click="addSymbol('∑')" href="#" class="logic-symbol">&sum;</a></li>
                          <li class="symbol-item"><a @click="addSymbol('Ω')" href="#" class="logic-symbol">&Omega;</a></li>
                          <li class="symbol-item"><a @click="addSymbol('∂')" href="#" class="logic-symbol">&part;</a></li>
                          <li class="symbol-item"><a @click="addSymbol('μ')" href="#" class="logic-symbol">&mu;</a></li>
                          <li class="symbol-item"><a @click="addSymbol('∫')" href="#" class="logic-symbol">&int;</a></li>
                          <li class="symbol-item"><a @click="addSymbol('π')" href="#" class="logic-symbol">&pi;</a></li>
                          <li class="symbol-item"><a @click="addSymbol('∞')" href="#" class="logic-symbol">&infin;</a></li>
                          <li class="symbol-item"><a @click="addSymbol('≈')" href="#" class="logic-symbol">&asymp;</a></li>

                          <li class="symbol-item"><a @click="addSymbol('≠')" href="#" class="logic-symbol">&ne;</a></li>


    				              <li class="symbol-item"><a @click="addSymbol('÷')" href="#" class="logic-symbol">&#247;</a></li>
    				              
    				              <li class="symbol-item"><a @click="addSymbol('−')" href="#" class="logic-symbol">&minus;</a></li>
    				              <li class="symbol-item"><a @click="addSymbol('√') "href="#" class="logic-symbol">&radic;</a></li>
    				              <li class="symbol-item"><a @click="addSymbol('+')" href="#" class="logic-symbol">&plus;</a></li>
    				              
    					 	    </b-dropdown-item>
    					 	  </b-dropdown>
    					 	  
    					</b-col>
    					<b-col sm="12" class="" style="padding-left:0;padding-right:0;">
    						    <!-- <b-link href="#" style="padding-left:15px;padding:10px 0 10px 15px">Upload Photo</b-link></b-button> --><br>
                    <b-form-file v-model="upload" :state="Boolean(upload)" placeholder="Choose a file..."></b-form-file>
                    <!-- <input type="file" id="doubt_attachment" name="file" value="Upload Photo" v-on:change="upload_change" placeholder="Upload" /> -->
    			        	<b-button class="btn query-btn button-touchy" variant="primary" style="margin-top: 20px; margin-left:0" @click="execute_add_doubt">Submit</b-button>
    					</b-col>
    				</b-row>
  			</b-container>
  		</div>
      </b-form>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'AddDoubt',
  data () {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        title:'',
        tags: 'quant',
        description:'',
        attachment:null
      },
      upload:null,
      doubt_tags: ['quant','di','verbal','gk','others']
    }
  },
  methods: {
    capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    onSubmit() {
      console.log('submitted');
      this.$router.push('/dashboard');
    },
    addSymbol(symbol) {
      this.form.description += symbol;
    },
    upload_change(val) {
      console.log('upload:',val);
    },
    async execute_add_doubt() {
      // validation

      if(this.form.title == '') {
        this.$toasted.show('Please enter the doubt title',{type:'error'});
        return;
      }

      if(this.form.description == '') {
        this.$toasted.show('Please enter the doubt description',{type:'error'});
        return;
      } 

      this.$store.commit('setLoader',true);
      console.log(this.upload);
      
      if(this.upload != null) {

        var FR = new FileReader();
      
        FR.onload = async (ev) => {
          console.log('file read success');
          this.form.attachment = btoa(ev.target.result);
          this.form.attachment_type = this.upload.type;
          try {
            var result = await this.$store.dispatch('add_doubt',this.form);
            this.$toasted.show('Doubt Added!',{type:'success'});
            this.$store.commit('setLoader',false);
            this.$router.push('/dashboard/solutions');
          } catch (ex) {
            this.$store.commit('setLoader',false);
            this.$toasted.show(ex.toString(),{type:'error'});
          }

        };

        FR.readAsBinaryString(this.upload);
      
      } else {
        try {
            var result = await this.$store.dispatch('add_doubt',this.form);
            this.$toasted.show('Doubt Added!',{type:'success'});
            this.$store.commit('setLoader',false);
            this.$router.push('/dashboard/solutions');
          } catch (ex) {
            this.$toasted.show(ex.toString(),{type:'error'});
        }
      }



      
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.add-query h2 {
  color:#262e3b;
  text-transform: uppercase;
  font-weight: bold;
}

.query-btn {
	position: relative;
	margin-left:10px;
	cursor: pointer;
}
#the_form {
  background:#262e3b;
  padding:20px;
  clear: both;
}
#the_form .form-control {
	border:none;
	border-radius: 0;
}
.query-btn {
	border-radius: 30px;
	background-color: #9bc538 !important;
}
.upload-btn {
  position: relative;
}
.file-upload {
  opacity:0;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.add-symbol {
  color:#fff;
  text-decoration:underline;
}
.symbol-list,.add-symbol {
  display:inline-block;
  vertical-align:middle;
  margin:0 20px 0 0;
}
.symbol-item {
  display:inline-block;
}
.symbol-list .dropdown-menu {
  min-width: 253px;
  border-radius:0;
}
.logic-symbol {
  padding:5px;
  border-radius:0 !important;
}
.symbol-list .notification {
  display:none;
}
.symbol-list li {
  list-style:none;
}
.symbol-list .dropdown-toggle {
  display:inline-block;
  width:30px;
  height:30px;
  background:url(../../../static/symbol.png);
  background-size:cover;
}
.dropdown-item:focus, .dropdown-item:hover {
	outline: 0;
	border:0;
	background-color: transparent;
}

@media screen and (min-width: 1280px) {
  .form-right-text {
    text-align: right;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/AddDoubt.vue